import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconEdit.tsx
const OutlinedFilledEdit = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M95-95v-176l573-573q9-10 22.5-15.5T718-865q13 0 26 5.5t25 14.5l77 74q10 12 15 25.5t5 27.5q0 14-5.5 27.5T846-667L272-95H95Zm628-585 40-39-42-43-41 40 43 42Z" })
});
const OutlinedEdit = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M188-189h45l421-420-43-44-423 421v43ZM95-95v-176l573-573q9-10 22.36-15.5Q703.71-865 718-865q13 0 26 5.5t25 14.5l77 74q10 12 15 25.5t5 27.5q0 14-5.5 27.5T846-667L272-95H95Zm668-624-42-43 42 43Zm-130 87-22-21 43 44-21-23Z" })
});
const RoundedFilledEdit = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M142-95q-20 0-33.5-13.5T95-142v-89q0-19 7.5-37t20.5-31l545-545q9-10 22.5-15.5T718-865q13 0 26 5.5t25 14.5l77 74q10 12 15 25.5t5 27.5q0 14-5.5 27.5T846-667L301-123q-14 13-31.5 20.5T233-95h-91Zm581-585 40-39-42-43-41 40 43 42Z" })
});
const RoundedEdit = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M188-189h45l421-420-43-44-423 421v43Zm-46 94q-20 0-33.5-13.5T95-142v-89q0-19 7.5-37t20.5-31l545-545q9-10 22.5-15.5T718-865q13 0 26 5.5t25 14.5l77 74q10 12 15 25.5t5 27.5q0 14-5.5 27.5T846-667L301-123q-14 13-31.5 20.5T233-95h-91Zm621-624-42-43 42 43Zm-130 87-22-21 43 44-21-23Z" })
});
const SharpFilledEdit = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M96-95v-176l622-623 181 174L273-95H96Zm627-585 40-39-42-43-41 40 43 42Z" })
});
const SharpEdit = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M188-189h45l421-420-43-44-423 421v43ZM95-95v-176l623-624 179 175L272-95H95Zm668-624-42-43 42 43Zm-130 87-22-21 43 44-21-23Z" })
});
const componentMap = {
	outlined: OutlinedEdit,
	"outlined-fill": OutlinedFilledEdit,
	rounded: RoundedEdit,
	"rounded-fill": RoundedFilledEdit,
	sharp: SharpEdit,
	"sharp-fill": SharpFilledEdit
};
const IconEdit = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconEdit };